module.exports = __webpack_public_path__ + "img/ADC-alt.b8568e4c.svg";